/* Résolution native par boutique : l'ancienne route avec companyId dans le
   chemin échoue dans l'authentification Loyoly (identifiant reçu en texte). */
(() => {
  const host = document.querySelector('[data-loyalty-program]');
  const frame = host?.querySelector('iframe');
  if (!frame) return;
  const url = new URL(frame.dataset.src);
  const params = {
    shop: host.dataset.shop,
    langcode: window.loyoly_lang_code ?? '',
    vh: document.documentElement.clientHeight,
    offset: Math.round(frame.getBoundingClientRect().top + window.scrollY),
    anchor: window.location.hash.slice(1),
    currencycode: window.loyoly_money_code ?? '',
    currencyrate: window.loyoly_convert_rate ?? '',
    langSuffix: window.loyoly_lang_suffix ?? '/',
    origin: window.location.origin,
  };
  for (const [key, value] of Object.entries(params)) url.searchParams.set(key, String(value));
  if (host.dataset.customerId) url.searchParams.set('customer_id', host.dataset.customerId);
  frame.src = url.toString();
  if (!document.querySelector('script[src="https://assets.loyoly.io/public/scripts/resize.js"]')) {
    const resize = document.createElement('script');
    resize.src = 'https://assets.loyoly.io/public/scripts/resize.js';
    resize.async = true;
    document.body.appendChild(resize);
  }
})();
